import { takeLatest, put } from 'redux-saga/effects'
import NProgress from 'nprogress'

import * as CONST from 'Reducers/Clients/const'
import * as ERRORS from 'Reducers/Errors/const'
import { callApi } from 'Reducers/apiCall'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

import { apiClient } from 'Module/API/Client'

/**
 * Get client by id
 */
function* getClientById(action) {
  NProgress.start()

  try {
    const response = yield callApi(apiClient.getClientById, action.payload.id)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_CLIENT_BY_ID_SUCCESS,
        payload: {
          clientView: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Update client by id
 *
 * @param action
 */
function* updateClientById(action) {
  const { callbacks, clientId, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(
      apiClient.updateClientById,
      clientId,
      payload,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.UPDATE_CLIENT_BY_ID_SUCCESS,
      })
      callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Create client
 *
 * @param action
 */
function* createClient(action) {
  const { callbacks, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(apiClient.createClient, payload)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.CREATE_CLIENT_SUCCESS,
      })
      callbacks.onSuccess(responseJson)
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get clients
 */
function* getClients() {
  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(apiClient.getClients)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_CLIENTS_SUCCESS,
        payload: {
          clients: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get client by id request watcher
 */
export function* watchGetClientById() {
  yield takeLatest(CONST.GET_CLIENT_BY_ID, getClientById)
}

/**
 * Update client by id request watcher
 */
export function* watchUpdateClientById() {
  yield takeLatest(CONST.UPDATE_CLIENT_BY_ID, updateClientById)
}

/**
 * Create client watcher
 */
export function* watchCreateClient() {
  yield takeLatest(CONST.CREATE_CLIENT, createClient)
}

/**
 * Get clients request watcher
 */
export function* watchGetClients() {
  yield takeLatest(CONST.GET_CLIENTS, getClients)
}



// WEBPACK FOOTER //
// ./src/Reducers/Clients/sagas.js